export default "__VITE_ASSET__1562ccf9__"